import { useMutation } from '@tanstack/react-query'

import { deleteSiteContact } from '@/features/site/endpoints/sites'

export type UseDeleteSiteContactMutationResult = ReturnType<typeof useDeleteSiteContactMutation>

export function useDeleteSiteContactMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (variables: { siteUuid: string; contactId: number; location: string }) =>
      deleteSiteContact({ siteUuid: variables.siteUuid, contactId: variables.contactId, location: variables.location }),
  })

  return {
    deleteSiteContact: mutateAsync,
    ...mutationResult,
  }
}
